import { IContactAddress } from '../address/address';
import { EntityReference } from '../basic/basic';
import { TransactionType } from '../structure';
import { IDocumentation } from './order';

export interface IOrderTransaction {
  orderTransactionID: number;
  deliveredTrackAndTraceID: string;
  deliveredTrackAndTraceURL: string;
  orderTransactionStatusType: OrderTransactionStatusType;
  statusOn: Date;
  deliveredOn: Date;
  availableOn: Date;
  message: string;
  type: TransactionType;
  documentations: IDocumentation[];
  shipmentOrders: EntityReference[];
  supplier: EntityReference;
  shippingAddress: IContactAddress;
  shippingMethod: EntityReference;
  invoiceAddress: IContactAddress;
  external_CMS_Number: string;
  external_Data: string;
  confirmedOn: Date;
  cancelledOn: Date;
  orderedOn: Date;
}

export enum OrderTransactionStatusType {
  NOT_DELIVERED = 0,
  DELIVERED = 1,
  READY = 2,
  ORDERED = 3,
  CONFIRMED = 4,
  CANCELLED = 5,
  DELIVERED_COMPLETE = 6,
  DELIVERED_CANCELLED = 7
}
